import { css } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 80],
    background: 'white',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s',
    // padding: '0px 70px'
    paddingLeft: ['0', '0', '3rem','3rem'],
    '@media (min-width: 1920px)': {
      paddingLeft: '20rem',
    },
    '@media (min-width: 2560px)': {
      paddingLeft: '25rem',
    },
  })),
  topScrolled: css(mq({
    height: [44, null, 80],
  })),
  topHeaderContainerWrapper: css(mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // maxWidth: '1800px',
    width: '100%',
    height: '100%',
  })),
  logo: css(mq({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s ease-in-out',
  })),
  logoImg: css(mq({
    display: 'block',
    height: [35, null, 80],
    maxHeight: '80%',
    transition: 'all 0.3s ease-in-out',
  })),
  logoImgScrolled: css(mq({
    height: [35, null, 80],
  })),
  logoScrolled: css(mq({
  })),
  topHeaderContainer: css(mq({
    // maxWidth: '1800px',
    display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'center',
    // width: '100%',
    marginRight: '2rem',
  })),
  topHeaderContainerRight: css(mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: '#492865',
    borderRadius: '40px 0 0 40px',
    // '@media (max-width: 768px)': {
    //   backgroundColor: 'transparent',
    // },
  })),
  top__navi__con__wrap: mq({
    background: "#002e5b",
    // padding: "5px 5px 2px",
    position: "relative",
    height: ["39px", null, "auto"],
  }),

  top__navi__item: mq({
    color: "white",
    fontSize: "0.8rem",
    position: "relative",
    svg: {
      paddingBottom: "3px",
      marginRight: "10px",
    },
    a: {
      color: "inherit",
      display: "inline-block",
      padding: "0.4rem 0.5rem 11px",
      fontWeight: 600,
      fontSize: "0.65rem",
      "&:hover": {
        textDecoration: "none",
        backgroundColor: "yellow",
      },
    },
  }),

  mast__head__svg__warpp: mq({
    position: "relative",
    // "&:before": mq({
    //   content: "''",
    //   width: "50%",
    //   left: 0,
    //   top: 0,
    //   height: "74px",
    //   position: "absolute",
    //   backgroundColor: "white",
    //   display: ["none", null, "block"],
    //   zIndex: "-1",
    //   transition: "all 0.5s ease",
    //   transform: "rotate(1deg)",
    //   "@media (min-width: 2561px)": {
    //     //display: 'block',
    //     transform: "rotate(0deg)",
    //   },
    // }),
    "&:after": mq({
      content: "''",
      width: "50%",
      right: 0,
      top: 0,
      height: "75%",
      position: "absolute",
      backgroundColor: "white",
      display: ["none", null, "block"],
      zIndex: "-1",
      transition: "all 0.5s ease",
      transform: "rotate(-1deg)",
      "@media (min-width: 2561px)": {
        //display: 'block',
        transform: "rotate(0deg)",
      },
    }),
  })
}